export { CombatOperationFeatured } from './CombatOperationFeatured';
